import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation } from "./EntityCommandInformation";
import { PartialNullable } from "./Extensions";
import { ObjectHelper } from "./Helpers/ObjectHelper";
import { StringHelper } from "./Helpers/StringHelper";
import { JNativeStatic } from "./JNative";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { ApplicationInformationService } from "./RadWindow";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ServerErrorHelper } from "./Server/ServerErrorHelper";
import { ServiceManager } from "./ServiceManager";
import { ErrorDialog } from "./Ui/Controls/ErrorDialog";
import { MessageDialog } from "./Ui/Controls/MessageDialog";

export type EntityCommandUserSendPasswordResetEmailPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandUserSendPasswordResetEmailProperties = {
    [name in keyof EntityCommandUserSendPasswordResetEmailPropertyValues]: Property<EntityCommandUserSendPasswordResetEmailPropertyValues[name]>
};

export interface IEntityCommandUserSendPasswordResetEmail extends IEntityCommand, EntityCommandUserSendPasswordResetEmailProperties
{
}

export class EntityCommandUserSendPasswordResetEmail extends EntityCommand<EntityCommandUserSendPasswordResetEmailPropertyValues> implements IEntityCommandUserSendPasswordResetEmail
{
    public static override classNamespace = NAMESPACE + "EntityCommandUserSendPasswordResetEmail";
    public static override className = "EntityCommandUserSendPasswordResetEmail";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandUserSendPasswordResetEmailPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Send Password Reset Email",
                entityName: "User",
                key: "SEND_PASSWORD_RESET_EMAIL",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Protected Methods

    protected _getUserEmailAddress(entityCommandInformation: EntityCommandInformation): string | undefined
    {
        return entityCommandInformation?.record.get()?.username;
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        userEmailAddress = this._getUserEmailAddress(entityCommandInformation);

                    let
                        error;

                    if (!userEmailAddress || !StringHelper.isEmailAddress(userEmailAddress))
                    {
                        error = "The users username is not a valid email address";

                        if (ErrorDialog)
                            ErrorDialog.displayError(error);
                        else
                            console.warn(error);

                        return;
                    }

                    return (
                        JNativeStatic
                            .ajax({
                                type: "POST",
                                data: ObjectHelper.toJson({ username: userEmailAddress }),
                                dataType: "json",
                                contentType: "application/json",
                                url: ServiceManager.getRequired(ApplicationInformationService).serverVirtualDirectory + "api/Security/RequestResetPassword"
                            })
                            .then(() =>
                            {
                                MessageDialog.displayMessage("Request Password Reset", "A password reset email has been sent.");
                            })
                            .catch(xhr =>
                            {
                                const
                                    error = ServerErrorHelper.processError(xhr);

                                ErrorDialog.displayError(error);

                                throw error;
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

